import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class SelectFieldController extends Controller {
  submit() {
    const form = this.element.closest('form');
    if (form) {
      form.requestSubmit();
    }
  }
}

application.register('ui--form--select-field', SelectFieldController);
